import AppIcon from "@/components/AppIcon";
import AppTextarea from "@/components/AppTextarea";
import ValidateMixin from "@/mixins/ValidateMixin.vue";
import ContentDisplayRulesMixin from "@/mixins/ContentDisplayRulesMixin.vue";
import EditPageContentPreview from "@/components/EditPageContentPreview.vue";
import Popper from "vue3-popper";
import { useVuelidate } from "@vuelidate/core";
import { computeLength } from "@/utils";
export default {
  name: "EditPageContentEdit",
  mixins: [ValidateMixin, ContentDisplayRulesMixin],
  emits: ["update:modelValue", "hide-comparison", "checkIsValid"],
  components: {
    AppIcon,
    AppTextarea,
    Popper,
    EditPageContentPreview
  },
  props: {
    modelValue: {
      type: [String, Array],
      default: ""
    },
    status: {
      type: String,
      default: "draft" // 'synced', 'published'
    },
    index: {
      type: Number,
      default: 0
    },
    scroll: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
    minimum_characters: {
      type: Number,
      default: 0
    },
    maximum_characters: {
      type: Number,
      default: 500
    },
    type: {
      type: String,
      default: ""
    },
    show_amazon_version: {
      type: Boolean,
      default: false
    },
    show_dropdown: {
      type: Boolean,
      default: false
    },
    allowHtmlInputAndSpecialCharacters: {
      type: Boolean,
      default: false
    },
    show_comparison: {
      type: Boolean,
      default: false
    },
    text_with_diffs: {
      type: String,
      default: ""
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      id: Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000,
      validationMap: {
        product_name: this.mValidateTitle,
        item_highlight: this.mValidateHighlight,
        generic_keyword: this.mValidateKeyword,
        product_description: this.mValidateDescription,
        bullet_points: this.mValidateBulletPoints
      },
      copied: false,
      amazon_icon_color: "#736BC9",
      localIsValid: true
    };
  },
  computed: {
    editText: {
      get() {
        return typeof this.modelValue == "string" ? this.modelValue : this.modelValue[this.index];
      },
      set(val) {
        let newValue = this.allowHtmlInputAndSpecialCharacters ? val : this.removeHtmlTagsAndSpecialCharacters(val);
        if (typeof this.modelValue != "string") {
          newValue = [...this.modelValue];
          newValue[this.index] = val;
        }
        this.$emit("update:modelValue", newValue);
      }
    },
    validation() {
      return this.getValidation();
    },
    validate() {
      return [{
        variable: "editText",
        rule: this.type
      }];
    },
    errorClass() {
      return !this.localIsValid;
    },
    characterCountInfo() {
      return this.getCharacterCountInfo();
    },
    amazonIconColor() {
      return this.amazon_icon_color;
    }
  },
  watch: {
    async editText() {
      this.$nextTick(async () => {
        this.localIsValid = await this.mValidate();
        this.$emit("checkIsValid", {
          type: this.type,
          index: this.index + 1,
          valid: this.localIsValid
        });
      });
    }
  },
  methods: {
    getValidation() {
      const validateMethod = this.validationMap[this.type];
      if (validateMethod) {
        return typeof this.modelValue == "string" ? validateMethod(this.modelValue) : validateMethod(this.modelValue[this.index]);
      }
      return {
        status: "error",
        text: "Invalid type"
      };
    },
    getCharacterCountInfo() {
      const valueLength = computeLength(this.type, this.editText);
      const isProductType = this.type === "product_name" || this.type === "item_highlight" || this.type === "generic_keyword";
      const maxCharacters = isProductType ? ` / ${this.maximum_characters}` : "";
      const plural = valueLength > 2 ? "s" : "";
      return `${valueLength}${maxCharacters} character${plural}`;
    },
    onCopy() {
      if (!this.copied) {
        navigator.clipboard.writeText(this.editText).then(this.setCopied);
      }
    },
    setCopied() {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 5000);
    },
    updateAmazonIconColor(color) {
      this.amazon_icon_color = color;
    },
    hideComparison() {
      this.$emit("hide-comparison");
    },
    hideTranslation() {
      this.$emit("hide-translation");
    }
  }
};